module.exports = __webpack_public_path__ + "img/Rodilleras para Pádel.3277a1cf.jpg";